<template>
  <div id="vote-friend-list" class="list-friend-box clearfix" v-show="dispFriendLists">
    <div class="list-friend-card clearfix" v-for="(friendList, indexRow) in filterFriendList(pageCurrent)" data-toggle="modal" data-target="#votefriend-popup" @click="togglePopup (friendList)">
      <div class="img-box">
        <img v-if="friendList.namimage" class="emp-img" :src="friendList.namimage">
        <img v-if="!friendList.namimage" class="emp-img" src="../../assets/img/no_image.png">
        <div v-if="friendList.dtevote === ''" class="hover-vote">{{ labels['VOTEFRIEND'][36] }}</div>
        <div v-if="friendList.dtevote !== ''" class="edit-vote"><i class="glyphicon glyphicon-ok-sign"></i><div>{{ labels['VOTEFRIEND'][37] }}</div></div>
      </div>
      <div v-show="friendList.dtevote" class="img-active"></div>
      <div class="name">{{ friendList.namempt }}</div>
      <div class="position">{{ friendList.desc_codpos }}</div>
      <div class="underline"></div>
      <div class="star">
        <div class="rate">
          <i class="fa fa-star" v-for="(rate, index) in stars" :class="setStar(index, friendList.score)"></i>
        </div>
      </div>
    </div>

    <div class="col-xs-12 page-box clearfix">
      <div @click="setCurrentPage(pageCurrent - 1)" :disabled="pageCurrent === 1" class="col-xs-2 direction">
        <span>&lt;</span> <span v-show="pcDisp">{{ labels['VOTEFRIEND'][8] }}</span>
      </div>
      <div class="col-xs-8 pages">
        <span class="page-label">{{ labels['VOTEFRIEND'][10] }}</span>
        <span v-for="indexPage in pageLists" @click="setCurrentPage(indexPage)" :class="'page ' + (indexPage === pageCurrent ? 'active' : '')">{{ indexPage }}</span>
      </div>
      <div @click="setCurrentPage(pageCurrent + 1)" :disabled="pageCurrent === maxPage" class="col-xs-2 direction right">
        <span v-show="pcDisp">{{ labels['VOTEFRIEND'][9] }}</span> <span>&gt;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vote-friend-list',
  data () {
    return {
      pageLists: [],
      dispFriendLists: false,
      stars: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
      }
    }
  },
  watch: {
    'friendLists' () {
      let calMaxPage = parseInt(this.friendLists.total / this.numberPerPage) + (parseInt(this.friendLists.total % this.numberPerPage) > 0 ? 1 : 0)
      this.setMaxPage(calMaxPage)
      this.dispFriendLists = true
    },
    'pageCurrent' () {
      this.calPagination()
    },
    'pcDisp' () {
      this.calPagination()
    },
    'maxPage' () {
      this.calPagination()
    }
  },
  methods: {
    setStar (rate, score) {
      let starStyle = 'hidden'
      if (rate <= score) {
        starStyle = 'text-yellow'
      }
      return starStyle
    },
    calPagination () {
      let numCalpage = 4
      if (!this.pcDisp) {
        numCalpage = 2
      }
      let numCalDiff = numCalpage - 1
      let pageStart = (this.pageCurrent <= numCalpage) ? 1 : (this.pageCurrent - numCalDiff)
      let pageEnd = (this.pageCurrent + numCalDiff) < (numCalpage + numCalDiff) && this.maxPage >= (numCalpage + numCalDiff) ? (numCalpage + numCalDiff) : (this.pageCurrent + numCalDiff)
      if (pageEnd > this.maxPage) {
        pageStart = this.maxPage - (numCalpage + numCalDiff) + 1
        pageEnd = this.maxPage
      }
      if (pageStart < 0) {
        pageStart = 1
      }
      this.pageLists = []
      for (var i = pageStart; i <= pageEnd; i++) {
        this.pageLists.push(i)
      }
    },
    setCurrentPage (pageNumber) {
      if (pageNumber > 0 && pageNumber <= this.maxPage) {
        this.setPageCurrent(pageNumber)
      }
    },
    filterFriendList (pageNumber) {
      return this.friendLists.rows.filter((friendList, index) => {
        return index < (pageNumber * this.numberPerPage) && index >= ((pageNumber * this.numberPerPage) - this.numberPerPage)
      })
    }
  },
  props: ['labels', 'nowLang', 'friendLists', 'pcDisp', 'pageCurrent', 'maxPage', 'numberPerPage', 'setPageCurrent', 'setMaxPage', 'togglePopup']
}
</script>



// WEBPACK FOOTER //
// voteFriendList.vue?49c80ab8